var _styleFn$propNames;

import styled from 'styled-components';
import { color, compose, space, verticalAlign } from 'styled-system';
import iconSizes from './iconSizes';

var NullIcon = function NullIcon() {
  return null;
};

var styleFn = compose(space, color, verticalAlign, iconSizes);
var stylePropNames = new Set();
(_styleFn$propNames = styleFn.propNames) === null || _styleFn$propNames === void 0 ? void 0 : _styleFn$propNames.forEach(function (propName) {
  return stylePropNames.add(propName);
}); // Naming it this way so the generated CSS class will start with "CactusIcon-".

var CactusIcon = /*#__PURE__*/styled(NullIcon).withConfig({
  shouldForwardProp: function shouldForwardProp(p) {
    return !stylePropNames.has(p);
  }
}).withConfig({
  displayName: "CactusIcon"
})(["vertical-align:middle;", ""], styleFn);
CactusIcon.displayName = 'AbstractIcon';
export default CactusIcon;